export function polishPlurals (singularNominativ, pluralNominativ, pluralGenitive, val) {
  const value = Math.abs(val)
  if (value === 1) return singularNominativ
  else if (value % 10 >= 2 && value % 10 <= 4 && (value % 100 < 10 || value % 100 >= 20)) return pluralNominativ
  else return pluralGenitive
}


// WEBPACK FOOTER //
// ./src/utils/Plurals.js